module.exports = __webpack_public_path__ + "static/img/mobile-img-05@m.3637bc7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/mobile-img-05@m.png
// module id = 3rGL
// module chunks = 0